// removed by extract-text-webpack-plugin
module.exports = {"form":"c-LoginForm__form","button":"c-LoginForm__button"};